import {
    IconLayoutDashboardFilled,
    IconCalendarMonth,
    IconPackages,
    IconUserSquareRounded,
    IconBuildings,
    IconCategoryFilled,
    IconPalette,
    IconGift,
    IconCalendarPlus,
    IconSettings,
    IconIdBadge2,
    IconQrcode,
    IconVideoPlus,
    IconVideo,
    IconBuildingStore,
    IconWorldWww,
    IconWorld,
    IconFiles,
    IconCake
} from "@tabler/icons-react";


export default function Icon(props) {
    if (props.name == "IconLayoutDashboardFilled")
        return <IconLayoutDashboardFilled size={props.size} className={props.className} />
    else if (props.name == "IconCalendarMonth")
        return <IconCalendarMonth size={props.size} className={props.className} />
    else if (props.name == "IconPackages")
        return <IconPackages size={props.size} className={props.className} />
    else if (props.name == "IconUserSquareRounded")
        return <IconUserSquareRounded size={props.size} className={props.className} />
    else if (props.name == "IconBuildings")
        return <IconBuildings size={props.size} className={props.className} />
    else if (props.name == "IconCategoryFilled")
        return <IconCategoryFilled size={props.size} className={props.className} />
    else if (props.name == "IconPalette")
        return <IconPalette size={props.size} className={props.className} />
    else if (props.name == "IconGift")
        return <IconGift size={props.size} className={props.className} />
    else if (props.name == "IconCake")
        return <IconCake size={props.size} className={props.className} />
    else if (props.name == "IconCalendarPlus")
        return <IconCalendarPlus size={props.size} className={props.className} />
    else if (props.name == "IconSettings")
        return <IconSettings size={props.size} className={props.className} />
    else if (props.name == "IconIdBadge2")
        return <IconIdBadge2 size={props.size} className={props.className} />
    else if (props.name == "IconQrcode")
        return <IconQrcode size={props.size} className={props.className} />
    else if (props.name == "IconVideo")
        return <IconVideo size={props.size} className={props.className} />
    else if (props.name == "IconVideoPlus")
        return <IconVideoPlus size={props.size} className={props.className} />
    else if (props.name == "IconBuildingStore")
        return <IconBuildingStore size={props.size} className={props.className} stroke={2} />
    else if (props.name == "IconWorldWww")
        return <IconWorldWww size={props.size} className={props.className} stroke={2} />
    else if (props.name == "IconWorld")
        return <IconWorld size={props.size} className={props.className} stroke={2} />
    else if (props.name == "IconFiles")
        return <IconFiles  size={props.size} className={props.className} stroke={2} />
    else if (props.name == "IconPackages")
        return <IconPackages  size={props.size} className={props.className} stroke={2} />
}